import { create } from 'zustand';
import type { NodeId } from 'web';

interface ExportNodeState {
  isProcessing: boolean;
  errorMessage?: string;
}

interface ExportStore {
  nodes: Record<string, ExportNodeState>;
  startExport: (nodeId: NodeId) => void;
  finishExport: (nodeId: NodeId, errorMessage?: string) => void;
}

export const useExportStore = create<ExportStore>()((set) => ({
  nodes: {},
  startExport: (nodeId) =>
    set((state) => ({
      nodes: { ...state.nodes, [nodeId]: { isProcessing: true, errorMessage: undefined } },
    })),
  finishExport: (nodeId, errorMessage) =>
    set((state) => ({
      nodes: { ...state.nodes, [nodeId]: { isProcessing: false, errorMessage } },
    })),
}));
